import { Keyboard, Move } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const MOTION_KEY = 'satr:reduced-motion:v1';

export function AccessibilitySettingsPage() {
  const { t } = useTranslation();
  const [reduced, setReduced] = useState(() => localStorage.getItem(MOTION_KEY) === 'true');
  useEffect(() => {
    document.documentElement.dataset.reducedMotion = reduced ? 'true' : 'false';
    localStorage.setItem(MOTION_KEY, String(reduced));
  }, [reduced]);
  return (
    <section className="settings-section">
      <h2>{t('settings.accessibility.title')}</h2>
      <p>{t('settings.accessibility.keyboardHelpDescription')}</p>
      <div className="setting-row">
        <div><strong><Move size={16} /> {t('settings.accessibility.motion')}</strong><small>{t('settings.accessibility.motionDescription')}</small></div>
        <label><input type="checkbox" checked={reduced} onChange={(event) => setReduced(event.currentTarget.checked)} /> {t('settings.accessibility.reducedMotion')}</label>
      </div>
      <div className="setting-row"><div><strong><Keyboard size={16} /> {t('settings.accessibility.keyboardHelp')}</strong><small>{t('settings.accessibility.keyboardHelpDescription')}</small></div></div>
    </section>
  );
}
